module.exports = __webpack_public_path__ + "media/images/icons/outlined/medicine-box-0be255c28e26d9973fd339c561243f4d.svg";